import { render, staticRenderFns } from "./user-balance-record.vue?vue&type=template&id=6f5b9b34&scoped=true&"
import script from "./user-balance-record.vue?vue&type=script&lang=js&"
export * from "./user-balance-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b9b34",
  null
  
)

export default component.exports